import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isObjectArray } from '../../../utilities/utilityFunctions';
import { hideMenu, selectLeadSorterDetail, setSortItem, toggleAscending, toggleMenu } from './reducerSlices/leadSorterSlice';

function LeadSorter(props) {
    const dispatch = useDispatch();
    const leadSorterDetail = useSelector(selectLeadSorterDetail);

    const sortByContainerRef = useRef(null);

    useEffect(() => {
        if (leadSorterDetail.open && sortByContainerRef && sortByContainerRef.current) {
            sortByContainerRef.current.focus();
        }
    });

    let _sortByList;
    if (isObjectArray(leadSorterDetail.sortByItems)) {
        if (leadSorterDetail.sortByItems.length > 0) {
            _sortByList = leadSorterDetail.sortByItems.map((sortByItem, index) => (
                <li
                    className="sort-by-menu-item"
                    onClick={(e) => onSortItemClicked(e, sortByItem.value, sortByItem.text)}>
                    {sortByItem.text}
                </li>
            ));
        }
    }

    const onBlur = (e) => {
        dispatch(hideMenu());
    };

    const onSorted = (e) => {
        dispatch(toggleAscending(!leadSorterDetail.ascending));
        props.onSorted && props.onSorted(leadSorterDetail.sortBy, !leadSorterDetail.ascending);
    };

    const onSortItemClicked = (e, value, text) => {
        dispatch(setSortItem({
            sortByText: text,
            sortBy: value,
            open: false
        }));
        props.onSorted && props.onSorted(value, leadSorterDetail.ascending);
    };

    const toggle = () => {
        dispatch(toggleMenu(!leadSorterDetail.open));
    };

    return (
        <div className="sort-by-container">
            <div>
                <span className="sort-by" onClick={(e) => toggle()}>{leadSorterDetail.sortByText}</span>
                {leadSorterDetail.open ? <div className="sort-by-menu"
                    ref={sortByContainerRef}
                    tabIndex={-1}
                    onBlur={(e) => onBlur(e)}>
                    <ul className="sort-by-menu-items">
                        {_sortByList}
                    </ul>
                </div> : <></>}
            </div>
            <span className="sort-button" onClick={(e) => onSorted(e)}><i className={leadSorterDetail.ascending ? "fa fa-chevron-down" : "fa fa-chevron-up"}></i></span>
        </div>
    );
}

export default LeadSorter;